// Tiny hook: returns true if the signed-in user has ever purchased credits.
// Used to swap the in-feed ad slot between the rewarded gate (free) and a
// scrollable house ad (paid). Independent of `useShouldShowAds` because that
// one short-circuits to `false` on Android — we still want to know paid
// status on Android for ad selection.
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function useIsPaidUser(): boolean | null {
  const { user } = useAuth();
  const [paid, setPaid] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user) { setPaid(false); return; }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("profiles")
        .select("credits_purchased_total")
        .eq("user_id", user.id)
        .maybeSingle();
      if (cancelled) return;
      setPaid(Number(data?.credits_purchased_total ?? 0) > 0);
    })();
    return () => { cancelled = true; };
  }, [user]);

  return paid;
}
